module.exports = __webpack_public_path__ + "img/marido-logo-no-bg.489ba9a3.png";